export function getSummaryRows(dailyPercentages: number[]) {
  return [
    ["Sum", "Daily"],
    ...dailyPercentages.map((dailyPercentage) => {
      const floatResult = parseFloat(`${dailyPercentage}`).toFixed(2);
      return ["100.00%", `${floatResult}%`];
    }),
  ];
}
